import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import cn from 'classnames';
import { ListView, ListViewHeader } from '@progress/kendo-react-listview';
import BaseButton, { DeleteButton } from '../buttons';

const UserFilterList = forwardRef(({ entity, onSelected, onDelete, getFilters, onAdd }, ref) => {
  const [filters, setFilters] = useState([]);
  const [selectedFilterId, setSelectedFilterId] = useState(0);

  const HeaderRenderer = () => (
    <ListViewHeader style={{ display: 'inline-flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className='my-filters-title' style={{ fontSize: '1.3em', borderBottom: '4px solid #31436e', width: '100%' }}>
        My Filters
      </div>
      <BaseButton size='small' icon='plus' onClick={onAdd} />
    </ListViewHeader>
  );

  const loadFilters = async () => {
    const myFilters = await getFilters(entity);
    setFilters(myFilters);
  };

  useImperativeHandle(ref, () => ({
    resetSelection: () => setSelectedFilterId(0),
    selectFilter: (id) => setSelectedFilterId(id),
    getFilterByName: (name) => filters.find((f) => f.name === name),
    reload: loadFilters,
  }));

  useEffect(() => {
    if (entity) {
      loadFilters();
    }
  }, [entity]);

  const handleItemSelected = (dataItem) => {
    setSelectedFilterId(dataItem.id);
    if (onSelected) {
      onSelected({ ...dataItem });
    }
  };

  const ItemRenderer = ({ dataItem }) => {
    const itemClassName = cn('filter-list-item', { active: selectedFilterId === dataItem.id });
    return (
      <div className={itemClassName}>
        <div onClick={() => handleItemSelected(dataItem)} className='filter-name'>
          {dataItem.name}
        </div>
        <div>
          <DeleteButton
            iconOnly
            fillMode='flat'
            style={{ float: 'right' }}
            onClick={() => onDelete(dataItem, selectedFilterId)}
          />
        </div>
      </div>
    );
  };

  return <ListView item={ItemRenderer} header={HeaderRenderer} data={filters} />;
});

export default UserFilterList;
